/* unplugin-vue-components disabled */import { render } from "./ContactChange.vue?vue&type=template&id=7b69d0a8&scoped=true&ts=true"
import script from "./ContactChange.vue?vue&type=script&lang=ts"
export * from "./ContactChange.vue?vue&type=script&lang=ts"

import "./ContactChange.vue?vue&type=style&index=0&id=7b69d0a8&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/plp-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b69d0a8"]])

export default __exports__